export default {
  computed: {
    localeConfiguration() {
      return {
        id: this.i18n.locale(),
        masks: {
          input: [this.i18n.t('date.formats.datepicker.date_only')],
          inputDateTime: [this.i18n.t('date.formats.datepicker.datetime_12h'), this.i18n.t('date.formats.datepicker.date_only')],
          inputDateTime24hr: [this.i18n.t('date.formats.datepicker.datetime_24h'), this.i18n.t('date.formats.datepicker.date_only')]
        }
      }
    }
  }
}
